import React from 'react'
import {CreateCollectionCom } from "components"
const CreateCollection = () => {
  return (
    <div><CreateCollectionCom/></div>
  )
}

export default CreateCollection